import { TOOLTIP_TEXTS } from "@/constants/tooltip-texts"

/** User-facing copy for target cards (tooltips, labels, etc.) */
export const TARGET_CARD_MESSAGES = {
  airtimeTitle: "Airtime",
  airtimeTooltip: TOOLTIP_TEXTS.targets.airtime,
  airtimeAriaLabel: "About Airtime",

  shareOfAirtimeTitle: "Share of Airtime",
  shareOfAirtimeTooltip: TOOLTIP_TEXTS.targets.shareOfAirtime,
  shareOfAirtimeAriaLabel: "About Share of Airtime",
} as const
